// This file is auto-generated by the "tsproxygen.exe" tool. Manual modification is not recommended.
import type FindFolderJsonRequest from '../contract/FindFolderJsonRequest';

export default function findFolderJsonRequest(data: FindFolderJsonRequest): FindFolderJsonRequest {
    const result: FindFolderJsonRequest = {
        __type: 'FindFolderJsonRequest:#Exchange',
        ...data,
    };

    return result;
}
